
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"-140.1 263 36 36","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M-133.5 268.8h22.8c1.2 0 2.1 1 2.1 2.1v20.2c0 1.2-1 2.1-2.1 2.1h-22.8c-1.2 0-2.1-1-2.1-2.1v-20.2c0-1.1 1-2.1 2.1-2.1zm2 21.8h19.1c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8h-19.1c-.4 0-.8.3-.8.8.1.5.4.8.8.8zm19.1-3.7c.4 0 .8-.3.8-.8v-9.5c0-.4-.3-.8-.8-.8h-19.1c-.4 0-.8.3-.8.8v9.5c0 .4.3.8.8.8h19.1zm0-13h-19.1c-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8h19.1c.4 0 .8.3.8.8s-.4.8-.8.8z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M-126 277.4h-4.7v7.9h4.7v-7.9zm-1.2 3.1l-1.1 2.2s-.1.1-.2.1h-.7c-.1 0-.1 0-.2-.1v-.2l1-1.8h-1c-.1 0-.2-.1-.2-.2v-.4c0-.1.1-.2.2-.2h1.9c.1 0 .1 0 .2.1l.1.5c.1-.1.1-.1 0 0zM-119.6 277.4h-4.7v7.9h4.7v-7.9zm-1.2 3.1l-1.1 2.2s-.1.1-.2.1h-.7c-.1 0-.1 0-.2-.1v-.2l1-1.8h-1c-.1 0-.2-.1-.2-.2v-.4c0-.1.1-.2.2-.2h1.9c.1 0 .1 0 .2.1l.1.5c0-.1 0-.1 0 0zM-118 285.2h4.7v-7.9h-4.7v7.9zm1.2-5.1c0-.1.1-.2.2-.2h1.9c.1 0 .1 0 .2.1l.1.3v.2l-1.1 2.2s-.1.1-.2.1h-.7c-.1 0-.1 0-.2-.1v-.2l1-1.8h-1c-.1 0-.2-.1-.2-.2v-.4z"}})])
          )
        }
      }
    